import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";  // Import useLocation
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from '../auth/AuthContext';
import Menu from "./Menu";
import logo from '@/components/images/logo.png'
import { faPowerOff, faPalette } from "@fortawesome/free-solid-svg-icons";
import avatar from "@/components/images/avatar.jpg"
import useMenuData from "./menuData";

const Navbar = () => {
    const menuData = useMenuData();

    const { user, setAccessToken } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();  // Hook to track the current location
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openSublist, setOpenSublist] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [userProfilePic, setUserProfilePic] = useState(avatar);




    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
        setOpenSublist(null);
    };

    const toggleSublist = (title) => {
        setOpenSublist(openSublist === title ? null : title);
    };

    const handleMenuHover = (index) => {
        setOpenDropdown(index);
        setOpenSublist(null);
    };

    const handleLogout = async () => {
        localStorage.removeItem('accessToken');
        setAccessToken(null);
        navigate("/login");
    };

    useEffect(() => {
        document.querySelector('body').classList.add('light')
    }, []);

    useEffect(()=>{

        setUserProfilePic(user?.profilePic)
    },[user])
      
    
    if (location.pathname === "/login" || location.pathname.startsWith("/set-password") || location.pathname.startsWith("/forgotpassword")) {
        return null; // Do not render Navbar on login page
    }

    return (
        <nav className="bg-[var(--mainCol)] shadow-md z-50 fixed w-full">
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-2 flex justify-between items-center">
                <Link to="/" className="text-xl font-bold text-gray-800 dark:text-white">
                    <img className='h-10' src={logo} alt="" />
                </Link>
                <div className="lg:hidden">
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                        <FontAwesomeIcon color="white" icon={isMobileMenuOpen ? faXmark : faBars} className="text-xl" />
                    </button>
                </div>
                <div className="hidden lg:block">
                    <Menu
                        menuData={menuData}
                        openDropdown={openDropdown}
                        openSublist={openSublist}
                        toggleDropdown={toggleDropdown}
                        toggleSublist={toggleSublist}
                        isMobile={false}
                        handleMenuHover={handleMenuHover}
                        currentPath={location.pathname}  // Pass current path as prop
                    />
                </div>

                <div className="userDiv flex items-center">
                    <Link to='/profile' className="h-full flex justify-center items-center cursor-pointer">
                        <img
                            className="rounded-full h-10 w-10 object-cover p-0.5 border border-white"
                            src={userProfilePic}
                            alt="User Profile"
                        />
                    </Link>
                    <FontAwesomeIcon icon={faPowerOff} color="white" onClick={handleLogout} className="cursor-pointer mx-2" />
                </div>

            </div>
            {isMobileMenuOpen && (
                <div className="lg:hidden px-4 pb-4">
                    <Menu
                        menuData={menuData}
                        openDropdown={openDropdown}
                        openSublist={openSublist}
                        toggleDropdown={toggleDropdown}
                        toggleSublist={toggleSublist}
                        isMobile={true}
                        currentPath={location.pathname}  // Pass current path as prop
                    />
                </div>
            )}
        </nav>
    );
};

export default Navbar;
